import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=5715a685&lang=pug&"
import script from "./sample.vue?vue&type=script&lang=js&"
export * from "./sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5715a685')) {
      api.createRecord('5715a685', component.options)
    } else {
      api.reload('5715a685', component.options)
    }
    module.hot.accept("./sample.vue?vue&type=template&id=5715a685&lang=pug&", function () {
      api.rerender('5715a685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sample/sample.vue"
export default component.exports